import { Box } from "@mui/material";
import { useMemo } from "react";
import { List, SelectInput, useRecordContext, useTranslate } from "react-admin";

import { DeviceEnrollmentScopeType, LocationQueryQuery, LocationTypeEnum } from "../generated/graphql";
import { DeviceDataGrid } from "./DeviceDataGrid";
import type { EnrollmentScopePreset } from "./deviceEnrollment/CreateDeviceEnrollmentTokenDialog";
import { DeviceEnrollmentSection } from "./deviceEnrollment/DeviceEnrollmentSection";
import { DEVICE_ENROLLMENT_STATUS_CHOICES } from "./deviceEnrollment/deviceEnrollmentStatusChoices";

type LocationRecord = NonNullable<LocationQueryQuery["location"]>;

const SCOPE_BY_LOCATION_TYPE: Partial<Record<string, DeviceEnrollmentScopeType>> = {
  [LocationTypeEnum.Site]: DeviceEnrollmentScopeType.Site,
  [LocationTypeEnum.Department]: DeviceEnrollmentScopeType.Department,
  [LocationTypeEnum.Ward]: DeviceEnrollmentScopeType.Ward,
};

export const LocationDevicesList = () => {
  const record = useRecordContext<LocationRecord>();
  const translate = useTranslate();

  const preset = useMemo<EnrollmentScopePreset | undefined>(() => {
    const scopeType = record?.type ? SCOPE_BY_LOCATION_TYPE[record.type] : undefined;
    return scopeType && record ? { scopeType, locationId: record.id } : undefined;
  }, [record]);

  if (!record) {
    return null;
  }

  return (
    <>
      <List
        resource="Device"
        filter={{ locationId: record.id }}
        filters={[
          <SelectInput
            key="enrollmentStatus"
            source="enrollmentStatus"
            label={translate("status")}
            choices={DEVICE_ENROLLMENT_STATUS_CHOICES}
            emptyText="deviceStatus.ALL"
            alwaysOn
          />,
        ]}
        perPage={50}
        actions={false}
      >
        <DeviceDataGrid showLocationColumn={false} />
      </List>
      <Box sx={{ mt: 4 }}>
        <DeviceEnrollmentSection organizationId={record.organization?.id ?? null} preset={preset} />
      </Box>
    </>
  );
};
